import Vue from 'vue';
import Router from 'vue-router';

import routes from './routes';
import { getInstance } from '@/auth';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach(async (to, from, next) => {
    const authService = getInstance();

    // Ignore auth guards if navigating to sign-in
    if (to.name === 'sign-in') {
        if (to.fullPath === from.fullPath) return next(false);
        return next();
    }

    // Otherwise, check auth0 for authentication or route to sign-in
    const navigateBasedOnAuth = () => {
        if (authService.isAuthenticated) return next();
        return next({ name: 'sign-in' });
    };

    // If loading has already finished, check our auth state
    if (!authService.loading) return navigateBasedOnAuth();

    // Watch loading property before we check isAuthenticated
    authService.$watch('loading', loading => {
        if (!loading) navigateBasedOnAuth();
    });
});

export default router;
